import { render, staticRenderFns } from "./LoadingBox.vue?vue&type=template&id=60a2fe69&scoped=true&"
import script from "./LoadingBox.vue?vue&type=script&lang=js&"
export * from "./LoadingBox.vue?vue&type=script&lang=js&"
import style0 from "./LoadingBox.vue?vue&type=style&index=0&id=60a2fe69&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a2fe69",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a2fe69')) {
      api.createRecord('60a2fe69', component.options)
    } else {
      api.reload('60a2fe69', component.options)
    }
    module.hot.accept("./LoadingBox.vue?vue&type=template&id=60a2fe69&scoped=true&", function () {
      api.rerender('60a2fe69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/helpers/LoadingBox.vue"
export default component.exports